import React from "react";
import Moment from "react-moment";
import moment from "moment";
import { DataFormats } from "../../../utils/constants";

const DEFAULT_PARSE_FORMATS = [
  "YYYY-MM-DD-HH-mm-ss-SSS",
  "YYYY-MM-DD-HH-mm-ss",
  "YYYY-MM-DD",
];

/**
 * Displays a date value formatted with moment if valid, otherwise the raw string.
 * @param {string} value - The date string or value to display
 * @param {string} format - Moment format for output (default: DD/MM/YYYY)
 * @param {string[]} parseFormats - Moment parse formats to try (default: common API formats)
 */
const DateDisplay = ({
  value,
  format = DataFormats.DATE_FORMAT_SHORT,
  parseFormats = DEFAULT_PARSE_FORMATS,
}) => {
  if (value == null || value === "") return null;

  const strValue = String(value);
  const isValidDate = moment(strValue, parseFormats).isValid();

  if (isValidDate) {
    return (
      <Moment date={strValue} parse={parseFormats} format={format} trim />
    );
  }

  return <>{strValue}</>;
};

export default DateDisplay;